module.exports = "/images/aerial-15.jpg";